import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { AuthenticationService } from './authentication.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private authenticationService: AuthenticationService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    return next.handle(request).pipe(catchError(err => {
      let message: string;
      if (err.status === 401) {
        // auto logout if 401 response returned from api
        message = localStorage.getItem('LOCALIZE_DEFAULT_LANGUAGE') == 'th' ? 'Session expired, Please login.':'Session expired, Please login.';
        this.authenticationService.logout(); //old
        this.authenticationService.removeToken(); //new
      } else if (err.status === 408 || err.status ===  504) {
        message = localStorage.getItem('LOCALIZE_DEFAULT_LANGUAGE') == 'th' ? 'Cannot connect to service backend.':'Cannot connect to service backend.';
        // this.authenticationService.logout(); //old
        this.authenticationService.removeToken(); //new
      } else if (err.status === 500) {
        message = localStorage.getItem('LOCALIZE_DEFAULT_LANGUAGE') == 'th' ? 'Something wrong, Please try again.':'Something wrong, Please try again.';
      } else if (err.status === 404) {
        // auto logout if 401 response returned from api
        message = localStorage.getItem('LOCALIZE_DEFAULT_LANGUAGE') == 'th' ? 'Page or url not founded.':'Page or url not founded.';
      } else if (err.status === 0) {
        // auto logout if 401 response returned from api
        message = localStorage.getItem('LOCALIZE_DEFAULT_LANGUAGE') == 'th' ? 'พบปัญหาในการเชื่อมต่อระบบ กรุณาออกจากระบบ และลงชื่อเข้าใช้งานใหม่อีกครั้ง':'There is a connection issue, please login again.';
      } else {
        message = localStorage.getItem('LOCALIZE_DEFAULT_LANGUAGE') == 'th' ? 'Server not respons.':'Server not respons.';
      }
      Swal.fire({
        title: 'Code ' + err.status,
        text: message,
        type: 'error',
        confirmButtonText: 'Close'
      });

      const error = err.error.message || err.statusText;
      return throwError(error);
    }));
  }
}
